/**
 * Polling intervals for real-time updates
 * All values in milliseconds
 */
export const POLLING_INTERVALS = {
  /** Task polling when tasks are active (2 seconds) */
  TASKS: 2000,

  /** Job history updates (10 seconds) */
  JOBS: 10000,

  /** Agent status updates (5 seconds) */
  AGENTS: 5000,
} as const;

/**
 * Timeout durations for async operations
 */
export const TIMEOUTS = {
  /** Cloudflare tunnel configuration timeout (30 seconds) */
  TUNNEL_CONFIG: 30000,

  /** Agent considered online if seen within this time (5 minutes) */
  AGENT_ONLINE: 5 * 60 * 1000,
} as const;

/**
 * React Query stale time configurations
 */
export const STALE_TIMES = {
  /** Task data considered stale after 1 second */
  TASKS: 1000,

  /** Job data considered stale after 5 seconds */
  JOBS: 5000,

  /** Agent list considered stale after 10 seconds */
  AGENTS: 10000,
} as const;
